import { FC, Fragment } from 'react';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Box, FactBox, Typography } from 'enova-frontend-components';

import { Varmekilde, VentilasjonsType } from '../../../../utils/registerEnums';
import { AboutFormControlProps, AboutFormData } from '../types';
import { EnumRadioGroup } from '../heating/components/enumRadioGroup';
import { EnumRadioButton } from '../heating/components/enumRadioButton';
import { ErrorMessage } from '../errors';

import { BalansertVentilasjonRadioButton } from './balansertVentilasjonRadioButton';

export const Ventilation: FC<AboutFormControlProps> = ({ control }) => {
  const { t } = useTranslation();

  const { formState } = useFormContext<AboutFormData>();

  const varmepumpeKilde = useWatch({
    control,
    name: 'oppvarming.oppvarmingVarmepumpe.varmeKilde'
  });

  const errors = formState.errors;

  // If Varmekilde.LuftFraVentilasjonsanlegg is selected we only display two options in ventilation section
  const isVarmepumpeFraVentilasjonsanlegg = varmepumpeKilde === Varmekilde.LuftFraVentilasjonsanlegg;

  return (
    <FactBox title={t('register.tekniskUtstyr.ventilasjon')} error={!!errors.ventilasjon}>
      <Typography variant="label">{t('register.ventilation.description')}</Typography>
      <Box py={3}>
        <Controller
          name="ventilasjon.ventilasjonType"
          control={control}
          rules={{
            required: t('register.ventilation.noSelection')
          }}
          render={({ field, fieldState }) => (
            <Fragment>
              <EnumRadioGroup onChange={field.onChange} value={field.value}>
                <Box display="flex" flexDirection="column" gap={3}>
                  {!isVarmepumpeFraVentilasjonsanlegg && (
                    <EnumRadioButton
                      hasHelperText
                      i18nPrefix="register.ventilation.option"
                      value={VentilasjonsType.Naturlig}
                    />
                  )}
                  {!isVarmepumpeFraVentilasjonsanlegg && (
                    <EnumRadioButton
                      hasHelperText
                      i18nPrefix="register.ventilation.option"
                      value={VentilasjonsType.PeriodiskAvtrekk}
                    />
                  )}

                  <EnumRadioButton
                    hasHelperText
                    i18nPrefix="register.ventilation.option"
                    value={VentilasjonsType.MekaniskAvtrekk}
                  />
                  {/* Balansert ventilasjon has additional form fields on select */}
                  <BalansertVentilasjonRadioButton control={control} />
                  {!isVarmepumpeFraVentilasjonsanlegg && (
                    <EnumRadioButton
                      hasHelperText
                      i18nPrefix="register.ventilation.option"
                      value={VentilasjonsType.Ukjent}
                    />
                  )}
                </Box>
              </EnumRadioGroup>
              {fieldState.error && <ErrorMessage error={fieldState.error} />}
            </Fragment>
          )}
        />
      </Box>
    </FactBox>
  );
};
